import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { LabelData, ProvisioningDialogFormType, ProvisioningEntry, ProvisioningFormType } from '../../integration-apps.types';

@Component({
  selector: 'app-integration-apps-instance-provisioning-dialog',
  templateUrl: './integration-apps-instance-provisioning-dialog.component.html',
  standalone: false
})
export class IntegrationAppsInstanceProvisioningDialogComponent implements OnChanges {

  @Input() showDialog: boolean = false;
  @Output() showDialogChange = new EventEmitter<boolean>();

  // use selectEntryType when more than labels are possible
  @Input() dialogContent: ProvisioningDialogFormType = 'fillForm';
  @Output() dialogContentChange = new EventEmitter<ProvisioningDialogFormType>();

  @Input() entryToEdit: ProvisioningEntry | undefined;
  @Output() addEntry = new EventEmitter<ProvisioningEntry>();

  public provisioningTypes: ProvisioningFormType[] = ['label'];
  public currentFormType: ProvisioningFormType = 'label';

  public currentEntry?: ProvisioningEntry;
  public formIsValid: boolean = false;

  // handles visibilty of the whole dialog
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['showDialog']?.currentValue === true) {
      this.onDialogOpened();
    }
  }

  private onDialogOpened() {
    if (this.entryToEdit) {
      this.currentEntry = { ...this.entryToEdit };
      this.currentFormType = this.entryToEdit.type as ProvisioningFormType;
      this.dialogContent = 'fillForm';
    } else {
      this.currentEntry = undefined;
      this.currentFormType = 'label';
      // use only when more than labels are possible
      // this.dialogContent = 'selectEntryType';
      this.dialogContent = 'fillForm';
    }
    this.dialogContentChange.emit(this.dialogContent);
  }

  hideTheDialog() {
    this.showDialog = false;
    // use only when more than labels are possible
    // this.dialogContent = 'selectEntryType';
    this.dialogContent = 'fillForm';
    this.showDialogChange.emit(false);
    this.dialogContentChange.emit(this.dialogContent);
  }

  selectEntryForm(formType: ProvisioningFormType) {
    this.currentFormType = formType;
    this.dialogContent = 'fillForm';
    this.dialogContentChange.emit(this.dialogContent);
  }

  formDataChanged(entry: ProvisioningEntry): void {
    this.currentEntry = {
      ...entry,
      id: this.entryToEdit?.id
    } as ProvisioningEntry;
  }

  emitData(): void {
    if (!this.currentEntry) {
      return;
    }
    this.addEntry.emit({
      ...this.currentEntry,
      id: this.entryToEdit?.id
    } as ProvisioningEntry);
    this.hideTheDialog();
  }

  formValidityChanged(valid: boolean): void {
    this.formIsValid = valid;
  }

  get canSubmit(): boolean {
    return this.formIsValid && !!this.currentEntry;
  }

  get currentLabelEntry(): LabelData | undefined {
    return this.currentEntry?.type === 'label'
      ? this.currentEntry
      : undefined;
  }
}
